<button
  mhFilterTrigger
  [filterOpen]="isOpen"
  (click)="isOpen = !isOpen"
  cdkOverlayOrigin #trigger="cdkOverlayOrigin"
>
  <i class="far fa-search tw-text-neutral-500"></i>
  <span class="tw-hidden tw-whitespace-nowrap tw-text-neutral-500 md:tw-inline">
    <ng-container *ngIf="!isAirline && !isRestaurant">
      {{'core-lib.selectors.guest.button' | translate}}
    </ng-container>
    <ng-container *ngIf="isAirline">
      {{'core-lib.selectors.guest.button_passenger' | translate}}
    </ng-container>
    <ng-container *ngIf="isRestaurant">
      {{'core-lib.selectors.guest.button_customer' | translate}}
    </ng-container>
  </span>
  <i class="fal fa-angle-down tw-hidden tw-text-base tw-ml-1 tw-text-neutral-400 md:tw-inline"></i>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
>
<div id="overlaySelectorGuest" class="tw-mt-3">

  <mh-core-lib-generic-box customClass="tw-h-fit">
    <mh-core-lib-autocomplete-input
        [options]="guests"
        [openBox]="true"
        [showGlassIcon]="true"
        [hasFirstTimeOptions]="hasOptions"
        [showOptions]="false"
        (writtenText)="writtenText.emit($event)"
        >
    </mh-core-lib-autocomplete-input>
  </mh-core-lib-generic-box>
</div>
</ng-template>
